export const PromotionRule = (json: IPromotionRule): IPromotionRuleModel => {
	const fromJSON = (itemJson: IPromotionRule) => {
		const { ...rest } = itemJson
		return {
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const promotionRuleToJSON = (obj: Partial<IPromotionRuleModel>): Partial<IPromotionRule> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}
